import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dccdea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between justify-content-sm-start align-items-center" }
const _hoisted_2 = { class: "m-0 mr-2 month" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_action = _resolveComponent("button-action")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.calendarForDay.monthLong) + " " + _toDisplayString(_ctx.calendarForDay.year), 1),
    _createVNode(_component_button_action, {
      i18nMessage: "common.monthPrev",
      prevM: true,
      onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.monthPrev())),
      class: "btn-calendar dis",
      btnDisabled: !_ctx.showBackButton()
    }, null, 8, ["btnDisabled"]),
    _createVNode(_component_button_action, {
      i18nMessage: "common.monthNext",
      nextM: true,
      onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.monthNext())),
      class: "btn-calendar"
    }),
    _createVNode(_component_button_action, {
      i18nMessage: "common.monthCurrent",
      onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.monthCurrent())),
      class: "btn-calendar d-none d-sm-block"
    })
  ]))
}